import { Add, Lock, MedicalServices, Subscriptions } from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import { useColorMode } from "src/context/ColorModeContext";
import {
  getUserName,
  hasChangedPassword,
  isUserAdministrator,
  isUserCompany,
  isUserPsychologist,
} from "src/utils/auth";
import CompanyBlockWarnings from "src/pages/components/CompanyBlockWarnings";
import Header from "../../components/Header";
import FastActionButton from "./components/FastActionButton";
import ActionLogbook from "src/pages/components/Logbook/ActionLogbook";

const Homepage: FC = (): JSX.Element => {
  const userName = useMemo(() => getUserName(), []);
  const isPsychologist = useMemo<boolean>(isUserPsychologist, []);
  const isCompanyUser = useMemo<boolean>(() => isUserCompany() && !isUserAdministrator(), []);
  const { mode } = useColorMode();

  return (
    <Box>
      <Header />

      <Box sx={{ width: "100%", textAlign: "center" }}>
        <CompanyBlockWarnings />

        <Typography sx={{ fontSize: { xs: "1.5rem", md: "2rem" }, padding: "1rem" }}>
          Bem vindo a Eezycare One <strong>{userName}</strong>
        </Typography>

        <Box
          component="img"
          src="/logo-horizontal.png"
          alt="Eezycare"
          sx={{
            width: { xs: "70%", sm: "50%", md: "35%", lg: "28%" },
            maxWidth: 500,
            mt: 1,
            mb: 1.5,
            filter:
              mode === "dark"
                ? "brightness(0) invert(1) drop-shadow(0 0 20px rgba(200,200,200,0.30))"
                : "none",
            transition: "transform 0.35s ease, filter 0.35s ease",
            "&:hover": {
              transform: "scale(1.06)",
              filter:
                mode === "dark"
                  ? "brightness(0) invert(1) drop-shadow(0 0 32px rgba(210,210,210,0.55))"
                  : "drop-shadow(0 6px 24px rgba(0,0,0,0.18))",
            },
          }}
        />

        {!hasChangedPassword() && (
          <Box sx={{ margin: { xs: "1rem", md: "1.5rem 4rem" } }}>
            <Typography sx={{ fontSize: "1.15rem", padding: "1rem" }}>
              Verificamos aqui que você ainda não atualizou sua senha padrão, por favor
              atualize-a, isso garante que sua conta seja cada vez mais segura!
            </Typography>
            <FastActionButton
              label="Alterar senha"
              redirectUrl="/usuario/alterar-senha"
              startIcon={<Lock />}
            />
          </Box>
        )}

        {isCompanyUser && (
          <Box sx={{ margin: { xs: "1rem", md: "1.5rem 4rem" }, textAlign: "left" }}>
            <ActionLogbook />
          </Box>
        )}

        {isPsychologist && (
          <Box sx={{ margin: { xs: "2rem 1rem", md: "4rem" } }}>
            <Typography sx={{ fontSize: "1.15rem", padding: "1rem" }}>
              Ações de acesso rápido
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FastActionButton
                  label="Meus atendimentos"
                  redirectUrl="/atendimentos"
                  startIcon={<MedicalServices />}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FastActionButton
                  label="Cadastrar atendimento"
                  redirectUrl="/atendimentos/cadastro"
                  startIcon={<Add />}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FastActionButton
                  label="Minhas ações"
                  redirectUrl="/acoes"
                  startIcon={<Subscriptions />}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FastActionButton
                  label="Cadastrar ação"
                  redirectUrl="/acoes/cadastro"
                  startIcon={<Add />}
                />
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Homepage;
